/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    
    export interface IInfoModalScope extends ng.IScope {
        title: string;
        description: string;
        modalClose: () => void;
    }
    
    /**
     * InfoModalController class
     */
    export class InfoModalController {
        public static templateURL: string = "decorators/modals/info-modal.html";
        public static ID: string = "#id-info-modal";
        public static $name: string = "infoModalController";
        public static $inject: string[] = ['$scope', 'close', 'title', 'description'];

        private $scope: IInfoModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IInfoModalScope, close: (parameters: ngModal.ICloseParameters) => void,
                    title: string, description: string) {
            this.$scope = $scope;
            this.$scope.title = title;
            this.$scope.description = description;            
            this.close = close;
            
            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };
        }
    }
}
